import { Signer } from 'aws-amplify';
import axios from 'axios';
import { CustomMidwayIdentityProvider } from './CustomMidwayIdentityProvider';

export const corsHeaders = {
  'Content-Type': 'application/json',
};

export class CustomMidwayIdentityClient extends CustomMidwayIdentityProvider {
  apiProps;
  httpClient;

  constructor(props) {
    super(props);
    this.apiProps = props;

    const baseURL = this.apiProps.httpEndpoint.startsWith('http')
      ? this.apiProps.httpEndpoint
      : `https://${this.apiProps.httpEndpoint}`;

    this.httpClient = axios.create({
      baseURL: baseURL,
    });

    this.httpClient.interceptors.request.use((request) => this.signRequest(request));
  }

  buildUrl(request) {
    const { url } = request;

    let host = this.apiProps.httpEndpoint.startsWith('http')
      ? this.apiProps.httpEndpoint
      : `https://${this.apiProps.httpEndpoint}`;

    if (host.endsWith('/') && url.startsWith('/')) {
      host = host.slice(0, -1);
    }
    const verifiedUrl = url ? (host.endsWith('/') || url.startsWith('/') ? host + url : `${host}/${url}`) : host;
    const finalUrl = request.params ? `${verifiedUrl}?${new URLSearchParams(request.params).toString()}` : verifiedUrl;
    return finalUrl;
  }

  async signRequest(request) {
    const credentials = await this.getCredentials();
    let headers;

    if (!this.apiProps.useJwtAuth) {
      headers = this.getSignedRequestHeaders(request, credentials);
    } else {
      headers = {
        authorization: `Bearer ${await this.getToken()}`,
        'x-identity-id': await this.getIdentityId(),
      };
    }

    return {
      ...request,
      headers: {
        ...corsHeaders,
        ...request.headers,
        ...headers,
      },
    };
  }

  getSignedRequestHeaders(request, credentials) {
    const signedRequest = Signer.sign(
      {
        url: this.buildUrl(request),
        method: request.method.toUpperCase() || 'GET',
        data: request.data ? JSON.stringify(request.data) : undefined,
      },
      {
        access_key: credentials.AccessKeyId || '',
        secret_key: credentials.SecretKey || '',
        session_token: credentials.SessionToken,
      },
      {
        region: this.apiProps.region,
        service: 'execute-api',
      }
    );
    return signedRequest.headers;
  }

  async getLogin() {
    return await super.getLogin();
  }

  async getCredentials() {
    return await super.getCredentials();
  }

  async request(props) {
    return this.httpClient.request(props);
  }
}



// WEBPACK FOOTER //
// ./src/client/CustomMidwayIdentityClient.jsx